import React from 'react';
import './ProjectSection.css';
import { getSkillIcon } from '../skills/SkillIconHelper';

const GitHubLogo = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M12 2C6.477 2 2 6.484 2 12.021c0 4.428 2.865 8.184 6.839 9.504.5.092.682-.217.682-.482 0-.237-.009-.868-.014-1.703-2.782.605-3.369-1.342-3.369-1.342-.454-1.157-1.11-1.465-1.11-1.465-.908-.62.069-.608.069-.608 1.004.07 1.532 1.032 1.532 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.339-2.221-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.987 1.029-2.686-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.025A9.564 9.564 0 0 1 12 6.844c.85.004 1.705.115 2.504.337 1.909-1.295 2.748-1.025 2.748-1.025.546 1.378.202 2.397.1 2.65.64.699 1.028 1.593 1.028 2.686 0 3.847-2.337 4.695-4.566 4.944.359.309.678.919.678 1.852 0 1.336-.012 2.417-.012 2.747 0 .267.18.577.688.479C19.138 20.2 22 16.447 22 12.021 22 6.484 17.523 2 12 2z"/>
  </svg>
);

const ExternalLinkLogo = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M14 5h5v5" />
    <path d="M10 14 19 5" />
    <path d="M19 13v5a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h5" />
  </svg>
);

function ProjectSection({ image, images, title, description, tech, github, external }) {
  const isCenteredTitle = title === 'Personal Website' || title === 'Arcane Chess' || title === 'Fitica' || title === 'WOOOLY' || title === 'Dataforma' || title === 'A-Eye';
  const displayImages = images || (image ? [image] : []);
  
  return (
    <div className="project-section">
      <div className="project-screenshots">
        {displayImages.map((img, idx) => (
          <img key={idx} src={img} alt={title + ' screenshot ' + (idx + 1)} className="project-screenshot" />
        ))}
      </div>
      <div className={`project-info ${isCenteredTitle ? 'centered-info' : ''}`}>
        <h1 className={`project-title ${isCenteredTitle ? 'centered-title' : ''}`}>{title}</h1>
        <div className="project-description-box">
          {description.split('\n\n').map((paragraph, idx) => (
            <p key={idx}>{paragraph}</p>
          ))}
        </div>
        <div className="project-tech-links">
          <div className="project-links">
            {github && (
              <a href={github} target="_blank" rel="noopener noreferrer" className="project-link" title="GitHub">
                <GitHubLogo />
              </a>
            )}
            {external && (
              <a href={external} target="_blank" rel="noopener noreferrer" className="project-link" title="External link">
                <ExternalLinkLogo />
              </a>
            )}
          </div>
          <div className="project-tech-icons">
            {tech && tech.map((techName, index) => (
              <div key={index} className="tech-icon" title={techName}>
                {getSkillIcon(techName)}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProjectSection; 